export default {
  fromStore(createdLinks, ganttInstance) {
    ganttInstance.batchUpdate(() => {
      createdLinks.forEach(createdLink => {
        const { sourceLinkId, targetLinkId } = createdLink;

        if (!ganttInstance.isLinkExists(sourceLinkId)) {
          return;
        }

        ganttInstance.silent(() => {
          ganttInstance.changeLinkId(sourceLinkId, targetLinkId);
        });
      });
    });
  },

  fromGantt() {

  },
};
